import { generateRandomToken } from '@shared/utilities';
import { useRef } from 'react';

export const useUuid = () => {
  const ref = useRef(generateRandomToken());

  return ref.current;
};
